<div class="camera-container" *ngIf="componentInitialized">
    <ng-container *ngTemplateOutlet="getTemplate()"></ng-container>
</div>

<!-- ACTIONS CONTAINER -->
<div class="actions-container">
    <ng-template [ngTemplateOutlet]="takePhotoTpl || takePhotoDefaultTpl"></ng-template>
    <ng-template [ngTemplateOutlet]="savePhotoTpl || savePhotoDefaultTpl"></ng-template>

    <ng-content></ng-content>
</div>

<ng-template #takePhoto>
    <button
        *ngIf="(!dataUrl && !photoSrc) && userCanTakePhoto"
        class="with-icon button primary"
        (click)="takeSnapshot()"
        [disabled]="isCameraActionsDisabled">
        <i class="icon-photo-camera1"></i>
        Take photo
    </button>
</ng-template>

<ng-template #savePhoto>
    <button
        *ngIf="dataUrl"
        class="button primary confirm-upload"
        [disabled]="isCameraActionsDisabled || uploadInProgress"
        (click)="uploadPhoto()">
        Confirm</button>
</ng-template>

<!-- SELECTED DEVICE template -->
<ng-template #connectedCamera>
    <video [class.show]="selectedDeviceId" #video [width]="width" [height]="height" autoplay muted playsinline></video>
    <canvas [class.show]="dataUrl" #canvas [width]="width" [height]="height"></canvas>

    <div *ngIf="selectedDeviceId && !photoSrc" class="overlay">
        <img src="../../assets/img/badge-requests/person-silhouette.png" alt="">
    </div>
</ng-template>

<!-- USER PHOTO template -->
<ng-template #userPhoto>
    <img [src]="photoSrc || '../../assets/img/badge-requests/no-photo.svg'" [width]="width" [height]="height">
</ng-template>

<!-- DEVICES DISABLED BY BROWSER template -->
<ng-template #disabledByBrowser>
    <i class="icon-exclamation_mark_circled"></i>
    <div class="camera-message">Camera disabled by browser. Please change settings for this site.</div>
</ng-template>

<!-- NOT SUPPORTED MEDIA SERVICES template -->
<ng-template #notSupportedMediaServices>
    <i class="icon-exclamation_mark_circled"></i>
    <div class="camera-message">Media device is not supported by browser.</div>
</ng-template>

<!-- DEVICES DISABLED BY OS template -->
<ng-template #disabledByOS>
    <i class="icon-exclamation_mark_circled"></i>
    <div class="camera-message">Camera isn't available</div>
</ng-template>
